import { useNavigate } from "react-router-dom";
import { useState, useCallback } from "react";
import { openExternalLink } from "../../utils/linkUtils";
import type { NavigationHandlers, NavigationState } from "./Navigation.types";

export const useNavigationHandlers = (): NavigationHandlers &
  NavigationState => {
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleMenuClick = useCallback(
    (path: string) => {
      navigate(path);
      setMobileMenuOpen(false); // Close mobile menu after navigation
    },
    [navigate]
  );

  const handleBookMeetingClick = useCallback(() => {
    openExternalLink("https://calendar.proton.me/bookings#GT-Th3lMCUvSdkTZP-GTcaxqPwWn8VJHP0MWzoiqkXk=");
  }, []);

  const handleMobileMenuToggle = useCallback(() => {
    setMobileMenuOpen((prev) => !prev);
  }, []);

  return {
    handleMenuClick,
    handleBookMeetingClick,
    handleMobileMenuToggle,
    mobileMenuOpen,
  };
};
